import Navigatie from "../../components/navigaties";
import Footers from "../../components/footers";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../components/breadcrumb";

function P_Student_Inschrijven(props) {
    function renderNav() {
        if (props.location.pathname.includes("student")) {
            return <Navigatie type="studenten" />;
        } else if (props.location.pathname.includes("bedrijf")) {
            return <Navigatie type="bedrijven" />;
        } else {
            return <Navigatie type="home" />;
        }
    }

    function renderBreadCrumb() {
        if (props.location.pathname.includes("student")) {
            return <BreadCrumb prev={[["/student", "Home"]]} now="Wefynd" />;
        } else if (props.location.pathname.includes("bedrijf")) {
            return <BreadCrumb prev={[["/bedrijf", "Home"]]} now="Wefynd" />;
        } else {
            return <BreadCrumb prev={[["/", "Home"]]} now="Wefynd" />;
        }
    }

    return (
        <div className="mr-t-33" style={{ color: "black" }}>
            <Helmet>
                <title>HR - inschrijven</title>
            </Helmet>
            {renderNav()}
            <div className="container w-71.5 xl-w-82.5 m-w-99">
                {renderBreadCrumb()}
                <div className="pd-4 mr-t-8">
                    <h1 className="mr-b-8">Schrijf je in voor het Job & Stage Event 2026!</h1>
                    <p>
                        De inschrijvingen voor het Job & Stage Event 2026 zijn binnenkort beschikbaar.<br />
                        Hou deze pagina in de gaten voor meer informatie.
                    </p>
                    <br />
                    <p>
                        Praktische informatie over het Job & Stage Event 2026 kan je <a href="https://recruitment.hermesgent.be/student/job-en-stage-event" style={{ color: "black" }}>hier</a> vinden.
                    </p>
                </div>
            </div>
            <Footers type="main" />
        </div>
    );
}

export default P_Student_Inschrijven;
